module.exports = function() {
	return new Worker(__webpack_public_path__ + "4152e86c1ac90decc5b7.soil-test-results.wrkr.js");
};